import React from 'react';
import { Video } from '../../models';
import { Button, Checkbox, TableCell, TableRow, Tooltip } from '@mui/material';
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { Link } from 'react-router-dom';

interface VideoTableRowProps {
  video: Video
  dark: boolean,
  selected: boolean,
  onVideoSelect?: (video: Video) => void
}

export const VideoTableRow: React.FC<VideoTableRowProps> = ({
  video,
  dark,
  selected,
  onVideoSelect,
}) => {
  const user = useCurrentUser()

  return (
    <TableRow className={dark ? 'dark_row' : 'light_row'}>
      {video.status === "src_issue" && (
        <div className="src-warning">
          <Tooltip title={"Source Error"}><GppMaybeIcon color="error" /></Tooltip>
        </div>
      )}
      <TableCell style={{ padding: "0.25rem 1.25rem" }}>
        <Checkbox className="table_cell" checked={selected} onChange={() => onVideoSelect?.(video)}></Checkbox>
      </TableCell>
      <TableCell className="table_cell">
        <div className="hover-image" title={video.title}>
          {video.title}
          {video.contentUrl ? (
            <div className="image-tooltip video-container">
              <video muted autoPlay style={{ width: "100%", height: "100%" }}>
                <source src={video.contentUrl} type="video/mp4" />
              </video>
            </div>
          ) : (
            <div className="image-tooltip"></div>
          )}
        </div>
      </TableCell>
      <TableCell className="table_cell">
        {new Date(video.createdAt).getDate()}/{new Date(video.createdAt).getMonth()+1}/{new Date(video.createdAt).getFullYear()}
      </TableCell>
      <TableCell>
        <div style={{ justifyContent: "space-between", display: "flex" }}>
          <Button component={Link} to={!user?.perms.p2 ? `/content/new-videos` : `/content/new-videos/${video.id}`} disabled={!user?.perms.p2} size="small" variant="contained" color="secondary">
            Edit
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
};